import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// images
import pimg1 from "../../images/partners/1.png";
import pimg2 from "../../images/partners/2.png";
import pimg3 from "../../images/partners/3.png";
import pimg4 from "../../images/partners/4.png";
import pimg5 from "../../images/partners/5.png";
import pimg6 from "../../images/partners/6.png";

const partners = [
  { id: "01", pimg: pimg1 },
  { id: "02", pimg: pimg2 },
  { id: "03", pimg: pimg3 },
  { id: "04", pimg: pimg4 },
  { id: "05", pimg: pimg5 },
  { id: "06", pimg: pimg6 },
];

const PartnerSection = (props) => {
  const settings = {
    infinite: true,
    autoplay: true,
    arrows: false,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1399, settings: { slidesToShow: 5 } },
      { breakpoint: 1199, settings: { slidesToShow: 5 } },
      { breakpoint: 991, settings: { slidesToShow: 4 } },
      { breakpoint: 757, settings: { slidesToShow: 3 } },
      { breakpoint: 575, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className={props.hclass || ""}>
      <h2 className="d-none">Partners</h2>

      <ul
        className="partners-slider"
        style={{
          padding: 0,
          margin: 0,
        }}
      >
        <Slider {...settings}>
          {partners.map((partner, index) => (
            <div key={index}>
              <li
                style={{
                  listStyle: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* SAME SIZE LOGO BOX */}
                <div
                  style={{
                    width: "180px",
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={partner.pimg}
                    alt="Partner Logo"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>
              </li>
            </div>
          ))}
        </Slider>
      </ul>
    </section>
  );
};

export default PartnerSection;
